"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORD_TABLE = void 0;
const react_1 = __importStar(require("react"));
const schemaComponents_1 = require("@/schemaComponents");
const hooks_1 = require("common/hooks");
const auth_1 = require("common/auth");
const models_hook_1 = require("app/models.hook");
const react_bootstrap_1 = require("react-bootstrap");
const url_1 = require("utils/url");
const route_1 = require("../../route");
const classes = __importStar(require("./WordTable.module.scss"));
const dataTransferSchema_1 = require("./dataTransferSchema");
const schema_1 = require("./schema");
const conditionSchema_1 = require("./conditionSchema");
const hooks_2 = require("./hooks");
const index_1 = require("../../../../index");
exports.WORD_TABLE = route_1.PROJECT.sub("/word-table", WordTable);
function WordTable({ projectId }) {
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const { value: langId, setValue: setLangId } = (0, hooks_1.useFieldAccessor)(searchParamAccessor, "langId");
    const { list: langList } = (0, models_hook_1.useLangList)({ projectId });
    const { list: systemLangList } = (0, models_hook_1.useSystemLangList)({});
    const { condition, conditionSelector } = (0, schemaComponents_1.useConditionSelector)({
        schema: (0, conditionSchema_1.getConditionSchema)({ langId }),
        hideTimeCondition: true,
    });
    const langIds = (0, react_1.useMemo)(() => langList === null || langList === void 0 ? void 0 : langList.map((item) => item.langId), [langList]);
    const systemLangMap = (0, react_1.useMemo)(() => Object.fromEntries((systemLangList === null || systemLangList === void 0 ? void 0 : systemLangList.map((item) => [item.langId, item.langName])) || []), [systemLangList]);
    const { list, loading, hasMore, fetching, refresher, reload } = (0, hooks_2.useWordTableListData)({
        projectId,
        langId,
        condition,
    });
    const parameter = (0, react_1.useMemo)(() => ({
        title: "単語リスト",
        edit: {
            path: ({ scriptId, segmentId }) => (0, index_1.resolveRoute)("UPDATE_SEGMENT_SCRIPT", { scriptId, projectId, segmentId }, { retainSearchParams: true }),
        },
        schema: (0, schema_1.getWordTableSchema)({ langId }),
        download: {
            schema: (0, dataTransferSchema_1.getDataTransferSchema)({ langIds }),
            filename: `word-table-${projectId}`,
        },
    }), [projectId, langId, langIds]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { style: { flex: "1 1 0", minHeight: 0 } },
            react_1.default.createElement(react_1.default.Fragment, null, loading || !list ? (react_1.default.createElement("div", { className: "card" },
                react_1.default.createElement("div", { style: { padding: "20px" } },
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", role: "status" },
                        react_1.default.createElement("span", { className: "visually-hidden" }, "Loading..."))))) : (react_1.default.createElement("div", { className: "card", style: { overflow: "auto" } },
                react_1.default.createElement("div", { className: classes.header, style: {
                        zIndex: 20,
                    } },
                    react_1.default.createElement(schemaComponents_1.SchemaInput, { data: langId, schema: {
                            schemaType: "selector",
                            options: [
                                ...(langList || [])
                                    .map((item) => ({
                                    value: item.langId,
                                    title: systemLangMap[item.langId],
                                }))
                                    .filter((item) => item.title),
                            ],
                        }, onValueChange: setLangId }))))),
            react_1.default.createElement(schemaComponents_1.SchemaListPage, { parameter: parameter, list: list, loading: loading, hasMore: hasMore, fetching: fetching, refresher: refresher, header: conditionSelector, reload: reload }))));
}
exports.default = WordTable;
